export class HelpInformation {
  gloassary: IHelpContent[] = [];
  faq: IHelpContent[] = [];
}

export interface IHelpContent {
  header: string
  entries: string[]
}
